import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AssignSpocsToRespondentsRPC } from "./assignSpocsToRespondentsRPC";

export class AssignSpocsToRespondentsRPCClientImpl extends AssignSpocsToRespondentsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AssignSpocsToRespondentsRPC.Request): Promise<LeoRPCResult<AssignSpocsToRespondentsRPC.Response, AssignSpocsToRespondentsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/AssignSpocsToRespondents",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AssignSpocsToRespondentsRPC.ResponseDTO,
      AssignSpocsToRespondentsRPC.Errors.ErrorsDTO,
      AssignSpocsToRespondentsRPC.Response,
      AssignSpocsToRespondentsRPC.Errors.Errors
    >(
      response,
      "spoc-management/AssignSpocsToRespondents",
      AssignSpocsToRespondentsRPC.Response.fromDTO,
      AssignSpocsToRespondentsRPC.Errors.fromDTO
    );
  }
}
